import React from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../atoms/button/LinkButton';
import Flight from './Flight';
import ItinerarySchedule from './ItinerarySchedule';
import { AIRLINES, BOOKING_CLASS_CLASS_J, ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';
import { getCarrierName } from '../../utils/plain';

const SubscriptionTableItem = ({
  index,
  outboundFlight,
  inboundFlight,
  dateDisplay,
  plan,
  handleFlightChange,
  handlePlanChange,
  handlePlanDelete,
  cantChangeHotel,
  cantDeleteHotel,
  handleUpdateCheckin,
  finalConfirm,
  hideCheckin,
  handleUpdateQuestion,
  showQuestions,
  hideMessage,
}) => {
  const rowSpan = (outboundFlight) ? 2 : 1;

  const flight = outboundFlight || inboundFlight;
  const connectingFlights = flight && flight.connectingFlights;

  const planItem = (
    <React.Fragment>
      <td className="tdItinerary">
        <ItinerarySchedule
          plan={plan}
          hideCheckin={cantChangeHotel}
          hideMessage={hideMessage}
          handleUpdateCheckin={handleUpdateCheckin}
          finalConfirm={finalConfirm}
          showQuestions={showQuestions}
          handleUpdateQuestion={handleUpdateQuestion}
        />
      </td>
      {finalConfirm ? (
        <td className="tdItineraryLast">
          <div className="mealItems">
            <div className="mealItem">
              {plan && plan.mealCondition}
            </div>
            {/* <div className="mealItem">
              夕食
              <span className="blue">あり</span>
            </div>
            <div className="mealItem">
              朝食
              <span className="red">なし</span>
            </div> */}
          </div>
          <div className="checkinTime">
            {!hideCheckin && plan && (
              <div className="checkin">
                <span className="name">チェックイン時間</span>
                <span className="time">{plan.checkin}</span>
              </div>
            )}
            {/* <div className="checkin">
              <span className="name">朝食時間</span>
              <span className="time">TODO 10:00</span>
            </div> */}
          </div>
          {showQuestions && plan && plan.questions && plan.questions.map((q, i) => (
            <div key={i} className="checkinTime">
              <div className="checkin">
                <span className="name">{`${q.title} :`}</span>
                <span className="time">{q.selectionText || '回答なし'}</span>
              </div>
            </div>
          ))}
        </td>
      ) : (
        <td className="tdLinkButton">
          {!cantChangeHotel && (
            <React.Fragment>
              <LinkButton onClick={handlePlanChange}>宿泊プランを変更する</LinkButton>
              {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>) }
              {!cantDeleteHotel && (
                <LinkButton
                  onClick={handlePlanDelete}
                  className="mt-15"
                >
                  宿泊施設を削除する
                </LinkButton>
              )}
            </React.Fragment>
          )}
          {ENABLE_MULTIPLE_HOTEL_PLAN && !plan && (
            <React.Fragment>
              <LinkButton onClick={handlePlanChange}>宿泊施設を追加する</LinkButton>
              {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
            </React.Fragment>
          )}
        </td>
      )}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <tr>
        <td rowSpan={rowSpan}>
          <div className="day">
            <div className="dayTitle">{index}日目</div>
            <div className="date">{dateDisplay}</div>
          </div>
        </td>
        {(outboundFlight || inboundFlight) ? (
          <React.Fragment>
            <td className="tdItinerary">
              <div className="itinerary">
                <div className="itineraryTitle">{outboundFlight ? '行き' : '帰り'}</div>
                <div>
                  <Flight
                    flight={outboundFlight || inboundFlight}
                    seat={!finalConfirm}
                    disabledFlightNumber={finalConfirm}
                  />
                </div>
              </div>
              <div className="mt-15 itineraryCaution">
                ※空港～宿泊施設間のアクセス・所要時間は、お客様ご自身でご確認ください。<br/>
                <span className="textRed">（現地移動につきましてはお客様負担となります）</span>
              </div>
            </td>
            {finalConfirm ? (
              <td>
                <FlightName
                  flight={flight}
                  connectingFlights={connectingFlights}
                />
              </td>
            ) : (
              <td className="tdLinkButton">
                <LinkButton onClick={handleFlightChange}>利用便を変更する</LinkButton>
              </td>
            )}
          </React.Fragment>
        ) : planItem}
      </tr>
      {outboundFlight && (
        <tr>
          {planItem}
        </tr>
      )}
    </React.Fragment>
  );
};

SubscriptionTableItem.propTypes = {
  index: PropTypes.number.isRequired,
  outboundFlight: PropTypes.object,
  inboundFlight: PropTypes.object,
  dateDisplay: PropTypes.string,
  plan: PropTypes.object,
  handleFlightChange: PropTypes.func.isRequired,
  handlePlanChange: PropTypes.func.isRequired,
  handlePlanDelete: PropTypes.func.isRequired,
  cantChangeHotel: PropTypes.bool,
  cantDeleteHotel: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  finalConfirm: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  hideMessage: PropTypes.bool,
};

export default SubscriptionTableItem;

const FlightName = ({ flight, connectingFlights }) => {
  if (!flight) {
    return null;
  }

  return connectingFlights && connectingFlights.length ? (
    <React.Fragment>
      <FlightNameItem flight={connectingFlights[0]} />
      <div style={{ height: 80 }} />
      <FlightNameItem flight={connectingFlights[1]} />
    </React.Fragment>
  ) : (
    <FlightNameItem flight={flight} />
  );
};

FlightName.propTypes = {
  flight: PropTypes.object,
  connectingFlights: PropTypes.array,
};

const FlightNameItem = ({ flight }) => {
  if (!flight) {
    return null;
  }

  const carrierName = getCarrierName(flight);

  return (
    <React.Fragment>
      <div className="tableFlightNumber" style={{ display: 'flex', alignItems: 'center' }}>
        {`${carrierName}${String(flight.flightID || flight.id || '').padStart(3, '0')}`}
        {flight.airline === AIRLINES.jal && flight.bookingClass === BOOKING_CLASS_CLASS_J && (
          <img src="/dpp/img/logo/jclass.png" alt="" style={{ height: 20, marginLeft: 5 }} />
        )}
      </div>
      {flight.operationCarrier && (
        <div>{flight.operationCarrier}運航</div>
      )}
    </React.Fragment>
  );
};

FlightNameItem.propTypes = {
  flight: PropTypes.object,
};
